module.exports = __webpack_public_path__ + "a768e7de/img/send-icon.3cfb6275.svg";